/*
 * @Author: caiqin.xie
 * @since: 2023-08-14 19:23:26
 * @lastTime: 2023-08-16 17:51:17
 * @LastEditors: huangfuchunmei
 * @message: 维修流程-流程列表
 */
import React from "react";
import { processList } from '@/common/const'
import styles from "../../index.module.scss";
import LazyMedia from "@/components/LazyMedia"

interface IProps {
  ctry: string;
  words: Record<string, string>;
}

const Process = (props:IProps) => {
  const {ctry, words} = props
  return (
    <section className={styles["process-section"]}>
      <h2 className={styles["section-title"]}>{words?.support_repair_process_title}</h2>
      {/* Repair process query */}
      <div className={styles["process-list"]}>
        {processList.map((item, index) => (
          <div className={styles["process-item"]} key={index}>
            <LazyMedia type="image" src={item.icon} alt="" />
            <p className={styles["process-item-title"]}>{words && words[item.title]}</p>
            <div className={styles["process-item-info"]}>
              {item.info.map((ite, idx) => (
                <p className={styles["info"]} key={idx}>{ite}</p>
              ))}
            </div>
          </div>
        ))}
        {/* 1 The equipment is faulty
        Online: Contact merchant services
        Offline: Contact dealers */}

        {/* 2 Make an appointment
        Online: Contact merchant services
        Offline: Contact dealers */}

        {/* 3 Inspection and maintenance
        Online: Contact merchant services
        Offline: Contact dealers */}

        {/* 4 Troubleshoot the issue
        Online: Contact merchant services
        Offline: Contact dealers */}

        {/* 5 Customer acceptance
        Online: Contact merchant services
        Offline: Contact dealers */}
      </div>
    </section>
  )
}
export default Process